export default "__VITE_ASSET__BPHzjpZI__"